/* SolutionsSwitcherCompactRenderer.js */

"use strict";
// const _ = require('lodash');
const SolutionsSwitcherRenderer = require("./SolutionsSwitcherRenderer");

class SolutionsSwitcherCompactRenderer extends SolutionsSwitcherRenderer {

    constructor(model) {
        let rootElem = document.createElement("solutions-switcher-compact"); //TODO Setup the root Element
        super(model,rootElem);
        this._arrowUp = document.createElement('div');
        this._arrowUp.classList.add('arrow');
        this.rootElement.appendChild(this._arrowUp);
        this._model.on('activeSolutionChanged', this._activeSolutionChanged = this._activeSolutionChanged.bind(this));
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _renderThat(){
        let showGroupLabel = false;
        super._renderThat(showGroupLabel);
    }

    _getSolutionSwitcherIconElem(item){
        let iconElem = super._getSolutionSwitcherIconElem(item);
        iconElem.classList.add('compact');
        return iconElem;
    }
    // eslint-disable-next-line no-unused-vars
    _activeSolutionChanged(details) {

    }

    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports=SolutionsSwitcherCompactRenderer;
